import { Component, OnInit } from '@angular/core';
import { InvoicesService } from '../services/invoices.service';
import { invoiceStatusConstant } from '../app.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivityLogsService } from '../services/activity-logs.service';


@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {


  constructor(
    private route: ActivatedRoute,
    private activityLogsService: ActivityLogsService,
  ) {
    this.activityLogsService.logPageVisit('invoices').subscribe();
  }

  ngOnInit(): void {
    
  }
}
